import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const AttemptsExhausted = ({
  setScreenNumber,
  telegramLink,
  onTelegramHandleClick
}) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <HeadContainer
        setScreenNumber={setScreenNumber}
        customTelegramLink={telegramLink}
        onTelegramHandleClick={onTelegramHandleClick}
        telegramOnly
      />
      <div className={styles.content}>
        <p className={styles.title}>Спроби вичерпані:(</p>
        <p className={styles.description}>
          Спробуй перевірити вказаний номер телефону та зареєструватися знову!
        </p>
        <button onClick={() => setScreenNumber(2)}>Перевірити номер</button>
      </div>
    </div>
  );
};

export default AttemptsExhausted;
